import { createContext, useContext, ReactNode, useState } from "react";
import { Alert, Snackbar, SnackbarCloseReason } from "@mui/material";
import { onShowLoading } from "../presentation/component/popup";

type LoadingContextValue = {
  showLoading: (isLoading: boolean) => void;
};

export const LoadingContext = createContext<LoadingContextValue>({
  showLoading: () => {},
});

export function LoadingProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  function showLoading(isLoading: boolean) {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    setOpen(isLoading);
  }

  return (
    <LoadingContext.Provider value={{ showLoading }}>
      {children}
      {onShowLoading(open)}
    </LoadingContext.Provider>
  );
}

export function useLoading() {
  const { showLoading } = useContext(LoadingContext);
  return { showLoading };
}
